"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/*
 * Measure scrollbar width for padding body during modal show/hide
 * const scrollbarMeasure = {
 *   position: 'absolute',
 *   top: '-9999px',
 *   width: '50px',
 *   height: '50px',
 *   overflow: 'scroll',
 * };
 * function measureScrollbar(direction = 'vertical') {
 *   if (typeof document === 'undefined' || typeof window === 'undefined') {
 *     return 0;
 *   }
 *   const scrollDiv = document.createElement('div');
 *   Object.keys(scrollbarMeasure).forEach(scrollProp => {
 *     scrollDiv.style[scrollProp] = scrollbarMeasure[scrollProp];
 *   });
 *   document.body.appendChild(scrollDiv);
 *   let size = 0;
 *   if (direction === 'vertical') {
 *     size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
 *   } else if (direction === 'horizontal') {
 *     size = scrollDiv.offsetHeight - scrollDiv.clientHeight;
 *   }
 */

/*
 *   document.body.removeChild(scrollDiv);
 *   return size;
 * }
 */

function measureScrollbar() {
  var outer = document.createElement('div');
  outer.style.visibility = 'hidden';
  outer.style.width = '100px';
  document.body.appendChild(outer);
  var widthNoScroll = outer.offsetWidth;
  outer.style.overflow = 'scroll';
  var inner = document.createElement('div');
  inner.style.width = '100%';
  outer.appendChild(inner);
  var widthWithScroll = inner.offsetWidth;
  outer.parentNode.removeChild(outer);
  return widthNoScroll - widthWithScroll;
}
var _default = exports.default = measureScrollbar;